import { ArrowRight } from "lucide-react";
import Header from "../Header";
import SpecificButton from "../../atoms/specificButton/SpecificButton";
import { useContext } from "react";
import { LanguageKeys } from "../../utils/languageKeys";
import { LanguageContext } from "../../utils/context/languageContext";
import { useConfig } from "../../utils/context/configContext";

function FaceScanErrorScreen({ onRetry, loading }: { onRetry?: () => void; loading?: boolean }) {
	const { translate } = useContext(LanguageContext) || {};
	const config = useConfig();

	return (
		<div data-testid="face-scan-error-screen" className="fixed common-ui-main  top-[0] left-[0] z-[999]  flex justify-center items-center w-full h-full" style={{ background: config?.style?.base?.backgroundColor }}>
			<div className="flex flex-col w-full items-center p-[1rem] rounded-lg  ">
				<Header noTitle />
				<div className="flex flex-col items-center w-full">
					<h2
						className="text-xl font-semibold text-gray-800 "
						style={{
							fontFamily: config?.style?.heading?.headingFontFamily || "SeriouslyNostalgic Fn",
							fontSize: config?.style?.heading?.headingFontSize || "32px",
							color: config?.style?.heading?.headingColor || "#000",
							fontWeight: config?.style?.heading?.headingFontWeight || "normal",
						}}
					>
						{translate?.(LanguageKeys.scanFailed)}
					</h2>
					<p
						className="mb-[1.5rem]"
						style={{
							fontFamily: config?.style?.subheading?.subheadingFontFamily || "'Inter', sans-serif",
							fontSize: config?.style?.subheading?.subheadingFontSize || "14px",
							color: config?.style?.subheading?.subheadingColor || "#4b5563",
							fontWeight: config?.style?.subheading?.subheadingFontWeight || "normal",
						}}
					>
						{translate?.(LanguageKeys.clickToResetScan)}
					</p>
					<SpecificButton
						data-testid="face-scan-retry-btn"
						disabled={loading}
						className="w-full h-[45px] shadow-[0px_1px_2px_0px_#00000040] text-[16px]"
						buttonText={translate?.(LanguageKeys.resetScan)}
						postfixIcon={<ArrowRight />}
						buttonFunc={() => onRetry?.()}
					/>
				</div>
			</div>
		</div>
	);
}

export default FaceScanErrorScreen;
